<template>
	<div>
		<div id="divcss5">
			<span class="item">总积分数：{{buyPoint+makePoint+unSurePoint}}</span>
			<!--20240308 关闭购买交互-->
			<!-- <span class="item">购买的分数：{{buyPoint}} </span>
			<span class="item">赚取的分数：{{makePoint}} </span>
			<span class="item">待售分数：{{unSurePoint}} </span>

			<span class="item" style="cursor:pointer;" @click="modal1 = true"><img
					:src="require('@/assets/image/element/gold.png')">购买积分</span>

			<span class="item" style="cursor:pointer;" @click="modal2 = true"><img
					:src="require('@/assets/image/element/gold.png')">出售积分</span> -->


			<Modal v-model="modal2" title="积分出售" @on-ok="okSale" @on-cancel="cancelSale">
				<Form ref="formValidateSale" :model="formValidateSale" :label-width="150">
					<Row>
						<Col align="right" :span="20">
						<FormItem label="最多可卖积分:" prop="maxSalePoint">
							<Input type="text" v-model="formValidateSale.maxSalePoint" disabled></Input>
						</FormItem>
						</Col>
					</Row>

					<Row>
						<Col align="right" :span="20">
						<FormItem label="出售积分:" prop="salePoint">
							<Input v-model="formValidateSale.salePoint" @on-keyup="intCheckSale()"></Input>
						</FormItem>

						</Col>
					</Row>
					
					<Row type="flex" justify="center" align="middle">
						<div>
							提示:购买的积分不能够出售，只能出售资源被购买赚取的积分
						</div>
					</Row>

				</Form>
			</Modal>

			<Modal v-model="modal1" title="购买积分" @on-ok="ok" @on-cancel="cancel">
				<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
					<Row>
						<Col align="right" :span="20">
						<FormItem label="购买积分:" prop="needBuyPoint">
							<Input v-model="formValidate.needBuyPoint" placeholder="请输入需要购买的积分数"
								@on-keyup="intCheck()"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col align="right" :span="20">
						<FormItem label="当前可用积分:" prop="nowPoint">
							<Input v-model="formValidate.nowPoint" disabled></Input>
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col align="right" :span="20">
						<FormItem label="需要缴费(元):" prop="needMonty">
							<Input v-model="formValidate.needMonty" disabled></Input>
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col align="center" :span="20">
						<p align="center">购买积分以实际缴费值为准</p>
						<img id="head-logo" :src="require('@/assets/image/money/money.png')">
						</Col>
					</Row>
				</Form>
			</Modal>

		</div>

		<Form ref="form" :model="pointDataTpye" :label-width="150" label-position="right">
			<Row type="flex" justify="center" align="middle">


				<Col :span="8">
				<FormItem label="积分变更类型：" prop="userType" label-for="userType">
					<Select v-model="pointDataTpye.changerId" placeholder="请选择积分变动类型" :label-in-value="true">
						<Option v-for="(item,index)  in pointChangerType" :value="item.changerId" :label="item.note"
							:key="index">{{item.note}}
						</Option>
					</Select>
				</FormItem>
				</Col>

				<Col v-bind="grid" class="ivu-text-right">
				<FormItem>
					<Button type="primary" @click="handleSubmit">查询</Button>
				</FormItem>
				</Col>

			</Row>
		</Form>

		<Table stripe :columns="columns1" :data="data1">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="show(index)">View</Button>
				<Button type="error" size="small" @click="remove(index)">Delete</Button>
			</template>
		</Table>
		<Page id="page" :total="pageTotal" :current="pageNum" :page-size="pageSize" @on-change="handlePage" show-total
			show-elevator next-text="下一页" />
	</div>
</template>
<script>
	//分页的初始参数
	const paramter = {
		page: 1,
		pagesize: 10,
		ispage: 'Y'
	};
	import {
		pointChangeList,
		getCurentInfo,
		pointSaleAdd,
		pointWaitsaletAdd,
		pointChangeTypeList
	} from '@/network/index.js';
	export default {
		inject: ['reload'],
		data() {
			return {

				columns1: [{
						title: '变更类型',
						key: 'changerName',
						
					},
					{
						title: '变更积分数',
						key: 'changerPoint'
					},
					{
						title: '变更时间',
						key: 'createTime',
						//	width: 250,
					},
					{
						title: '变更前积分',
						key: 'createBeforePoint'
					},
					{
						title: '变更后积分',
						key: 'createAfterPoint'
					}

				],
				data1: [],
				pageTotal: 0,
				pageNum: 1,
				pageSize: 10,
				buyPoint: 0,
				makePoint: 0,
				unSurePoint: 0,
				modal1: false,
				modal2: false,
				formValidate: {
					needBuyPoint: '',
					nowPoint: 0,
					needMonty: 0,
				},
				formValidateSale: {
					maxSalePoint: 0,
					salePoint: 0,
				},
				ruleValidate: {
					needBuyPoint: [{
						message: '请输入要购买的积分数',
						trigger: 'change'
					}]
				},
				pointDataTpye: {
					changerId: '',
				},
				pointChangerType: [],
				//如下是查询条件的
				grid: {
					xl: 8,
					lg: 8,
					md: 12,
					sm: 24,
					xs: 24
				},


			}
		},
		created() {
			this.initData();


		},
		methods: {

			intCheck() {
				if (this.formValidate.needBuyPoint == 0) {
					this.formValidate.needBuyPoint = ""
				} else {
					this.formValidate.needBuyPoint = this.formValidate.needBuyPoint.replace(/\D/g, '')
				}
				//debugger;
				this.formValidate.needMonty = this.formValidate.needBuyPoint / 10;

			},





			//页面变更
			handlePage(value) {
				console.log('value:' + value);
				this.pageNum = value;
				paramter.page = value;

				this.initData()
			},
			initData() {
				let paramter = {
					userLoginId: this.$store.state.userInfo.loginId,
				};


				getCurentInfo(paramter).then(res => {
						this.buyPoint = res.data.obj.buyPoint;
						this.makePoint = res.data.obj.makePoint;
						this.unSurePoint = res.data.obj.unSurePoint;
						this.formValidate.nowPoint = Number(this.makePoint) + Number(this.buyPoint) ;
						this.formValidateSale.maxSalePoint = this.makePoint;

					})
					.catch(error => {});

				let paramterTemp = {
					userLoginId: this.$store.state.userInfo.loginId,
					ifValid: '1'
				};
				pointChangeList(paramterTemp).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								changId: res.data.obj.dataList[i].changId,
								changerName: res.data.obj.dataList[i].changerName,
								changerPoint: res.data.obj.dataList[i].changerPoint,
								resourcesId: res.data.obj.dataList[i].resourcesId,
								createTime: res.data.obj.dataList[i].createTime,
								createBeforePoint: res.data.obj.dataList[i].createBeforePoint,
								createAfterPoint: res.data.obj.dataList[i].createAfterPoint,
							});


						}

					})
					.catch(error => {});


				// debugger;
				//获取积分变更字典表
				pointChangeTypeList().then(res => {
						this.pointChangerType.push({
							changerId: '99999',
							note: '请选择'
						});
						for (var i = 0; i < res.data.obj.dataList.length; i++) {

							this.pointChangerType.push({
								changerId: res.data.obj.dataList[i].changerId,
								note: res.data.obj.dataList[i].note
							});
						}

					})
					.catch(error => {});
			},

			show(index) {
				this.$Modal.info({
					title: 'User Info',
					content: `downloadId：${this.data1[index].downloadId}<br>resourcesId：${this.data1[index].resourcesId}<br>title：${this.data1[index].title}`
				})
			},
			remove(index) {
				this.data1.splice(index, 1);
			},

			//积分购买ok
			ok() {
				let paramterTemp = {
					//userLoginId: this.$store.state.userInfo.loginId,
					payPoint: this.formValidate.needBuyPoint,
				};
				pointSaleAdd(paramterTemp).then(res => {
						this.$Message.success('购买成功');
						//刷新当前页面
						this.reload();

					})
					.catch(error => {});
			},
			//积分购买取消
			cancel() {
				this.$Message.info('取消购买！');
			},


			intCheckSale() {
				if (this.formValidateSale.salePoint == 0) {
					this.formValidateSale.salePoint = ""
				} else {
					this.formValidateSale.salePoint = this.formValidateSale.salePoint.replace(/\D/g, '')
				}

				if (this.formValidateSale.salePoint > this.formValidateSale.maxSalePoint) {
					this.$Message.error('出售的积分大于拥有的积分！');
					this.formValidateSale.salePoint = this.formValidateSale.maxSalePoint
				}

			},

			//积分出售ok
			okSale() {

				if (this.formValidateSale.salePoint == 0) {
					this.$Message.error('没有积分不能出售！');
					return;

				}

				let paramterTemp = {
					waitPoint: this.formValidateSale.salePoint,
				};
				pointWaitsaletAdd(paramterTemp).then(res => {
						this.$Message.success('积分出售挂单成功');
						//刷新当前页面
						this.reload();

					})
					.catch(error => {});
			},
			//积分出售取消
			cancelSale() {
				this.$Message.info('取消购买！');
			},

			//查询提交
			handleSubmit() {
				let paramterTemp = {
					userLoginId: this.$store.state.userInfo.loginId,
					changerId: this.pointDataTpye.changerId,
					ifValid: '1'
				};
				pointChangeList(paramterTemp).then(res => {
						// console.log(res);
						this.pageTotal = res.data.page.count;
						this.pageSize = res.data.page.pagesize;
						this.pageNum = res.data.page.page;
						//数据清空
						this.data1 = [];
						for (var i = 0; i < res.data.obj.dataList.length; i++) {
							this.data1.push({
								changId: res.data.obj.dataList[i].changId,
								changerName: res.data.obj.dataList[i].changerName,
								changerPoint: res.data.obj.dataList[i].changerPoint,
								resourcesId: res.data.obj.dataList[i].resourcesId,
								createTime: res.data.obj.dataList[i].createTime,
								createBeforePoint: res.data.obj.dataList[i].createBeforePoint,
								createAfterPoint: res.data.obj.dataList[i].createAfterPoint,
							});


						}

					})
					.catch(error => {});
			},
		},


	}
</script>


<style lang="scss" scoped>
	
	.ivu-form-item {
		margin-bottom: 10px;
		margin-top: 10px;
	}
	#divcss5 {
		display: flex; //水平分布
		border: 1px dashed #ff0000;
		height: 30px;
		width: 100%;


	}

	.item {
		flex: 1; //等分
		text-align: center; //等分后居中
		font-size: 18px;
	}


	#head-logo {
		width: 200px;
		height: 200px;
		text-align: center;
		border-radius: 3px; //添加圆角
	}
</style>
